// Vendor
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
// Actions
import { resetClientResultsLoaded, resetSelectedMatrices, selectClient, setClientResultsLoaded, } from 'IntegrationsApp/ts/features/integrations-shared/state/hartford-import-holdings/actions';
// Selectors
import { INTEGRATIONS_STATE_SLICE_KEY } from 'IntegrationsApp/ts/features/integrations-shared/state/integrations-shared.reducer';
import { getSelectedClient } from 'IntegrationsApp/ts/features/integrations-shared/state/hartford-import-holdings/import-holdings.selectors';
// Constants
import { INITIAL_SIMPLE_PAGINATION_STATE } from 'Angular/features/components/pagination/pagination.constants';
import { HartfordIntegrationService } from 'IntegrationsApp/ts/services/hartford-integration-service';
// Services
import { IntegrationErrorHandlingService } from 'IntegrationsApp/ts/services/shared/integration-error-handling-service';
// Base directive
import { IntegrationSearchModalBase } from 'IntegrationsApp/ts/features/integrations-shared/directives/integration-search-modal-base/integration-search-modal-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/shared/integration-error-handling-service";
import * as i2 from "IntegrationsApp/ts/services/hartford-integration-service";
import * as i3 from "@ngrx/store";
import * as i4 from "@angular/common";
import * as i5 from "@angular/forms";
import * as i6 from "../../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i8 from "IntegrationsApp/ts/features/integrations-shared/components/hartford-import-holdings/search-results/client-list-results.component";
function HartfordClientSearchModalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.errorMessage);
} }
function HartfordClientSearchModalComponent_div_2_option_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "option", 12);
} if (rf & 2) {
    const territory_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", territory_r3.id)("innerText", territory_r3.name);
} }
function HartfordClientSearchModalComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "label", 8);
    i0.ɵɵtext(2, "Territory:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "select", 9);
    i0.ɵɵlistener("change", function HartfordClientSearchModalComponent_div_2_Template_select_change_3_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onTerritoryChange($event.target.value)); });
    i0.ɵɵelementStart(4, "option", 10);
    i0.ɵɵtext(5, "All");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, HartfordClientSearchModalComponent_div_2_option_6_Template, 1, 2, "option", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r0.selectedTerritoryId);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.territories);
} }
function HartfordClientSearchModalComponent_div_3_ycn_loading_symbol_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 21);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function HartfordClientSearchModalComponent_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "ycn-hartford-client-list-results", 23);
    i0.ɵɵlistener("pageChangeHandler", function HartfordClientSearchModalComponent_div_3_div_7_Template_ycn_hartford_client_list_results_pageChangeHandler_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.submit($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("serializedClients", ctx_r0.serializedClients)("paginationInfo", ctx_r0.paginationInfo);
} }
function HartfordClientSearchModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14)(2, "div", 15);
    i0.ɵɵelement(3, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵlistener("click", function HartfordClientSearchModalComponent_div_3_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.edit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, HartfordClientSearchModalComponent_div_3_ycn_loading_symbol_6_Template, 1, 1, "ycn-loading-symbol", 19)(7, HartfordClientSearchModalComponent_div_3_div_7_Template, 2, 2, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerText", ctx_r0.searchTerms);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-edit");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.displayClientSearchResults());
} }
function HartfordClientSearchModalComponent_div_4_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 30)(1, "div", 31);
    i0.ɵɵlistener("click", function HartfordClientSearchModalComponent_div_4_span_7_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.submit(ctx_r0.paginationInfo.current_page_num)); });
    i0.ɵɵtext(2, " Submit ");
    i0.ɵɵelementEnd()();
} }
function HartfordClientSearchModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25)(2, "input", 26, 0);
    i0.ɵɵlistener("input", function HartfordClientSearchModalComponent_div_4_Template_input_input_2_listener() { i0.ɵɵrestoreView(_r6); const searchInput_r7 = i0.ɵɵreference(3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.setSearchTerms(searchInput_r7.value)); })("keydown.enter", function HartfordClientSearchModalComponent_div_4_Template_input_keydown_enter_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.submit(ctx_r0.paginationInfo.current_page_num)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 27)(5, "div", 28);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 18);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(7, HartfordClientSearchModalComponent_div_4_span_7_Template, 3, 0, "span", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const searchInput_r7 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", "Search by client name")("value", ctx_r0.searchTerms);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", "icon-search");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", searchInput_r7.value);
} }
export class HartfordClientSearchModalComponent extends IntegrationSearchModalBase {
    constructor(integrationErrorService, hartfordIntegrationService, store) {
        super();
        this.integrationErrorService = integrationErrorService;
        this.hartfordIntegrationService = hartfordIntegrationService;
        this.store = store;
        this.openModalHandler = new EventEmitter();
        this.searchTerms = '';
        this.submitted = false;
        this.loading = false;
        this.errorMessage = '';
        this.serializedClients = [];
        this.paginationInfo = INITIAL_SIMPLE_PAGINATION_STATE;
        this.territories = [];
        this.selectedTerritoryId = '';
        this.mapStateToComponent = (state) => {
            this.selectedClient = getSelectedClient(state);
        };
        this.storeSubscription = this.store.select(INTEGRATIONS_STATE_SLICE_KEY).subscribe(this.mapStateToComponent);
        this.loadTerritories();
    }
    loadTerritories() {
        this.hartfordIntegrationService.getHartfordTerritories().subscribe({
            next: (data) => {
                this.territories = data.territories;
            },
            error: () => {
                this.territories = [];
            },
        });
    }
    onTerritoryChange(territoryId) {
        this.selectedTerritoryId = territoryId;
        if (this.submitted) {
            this.submit(1);
        }
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    setSearchTerms(searchTerms) {
        this.searchTerms = searchTerms;
        this.submitted = false;
    }
    edit() {
        this.resetModalHelper();
    }
    resetModalHelper() {
        this.errorMessage = '';
        this.paginationInfo = INITIAL_SIMPLE_PAGINATION_STATE;
        this.store.dispatch(resetSelectedMatrices());
        this.store.dispatch(resetClientResultsLoaded());
        this.store.dispatch(setClientResultsLoaded({ loaded: false }));
        this.store.dispatch(selectClient({ selectedClient: null }));
        this.selectedClient = null;
        this.loading = false;
        this.submitted = false;
    }
    submit(page) {
        super.submit();
        this.loading = true;
        this.hartfordIntegrationService
            .getHartfordClientSearchResults(this.searchTerms, page, this.selectedTerritoryId || undefined)
            .subscribe({
            next: (data) => {
                this.serializedClients = data.searchResults;
                this.paginationInfo = data.paginationInfo;
                if (this.serializedClients.length === 0) {
                    this.errorMessage = 'No results found.';
                }
                this.loading = false;
                this.store.dispatch(setClientResultsLoaded({ loaded: true }));
            },
            error: (res) => {
                this.errorMessage = this.integrationErrorService.handleSearchErrorResponse(res);
                this.loading = false;
            },
        });
    }
    displayClientSearchResults() {
        return this.serializedClients.length !== 0 && !this.loading;
    }
    resetModal() {
        this.searchTerms = '';
        this.resetModalHelper();
    }
    cancelHandler() {
        this.resetModalHelper();
    }
    submitHandler() {
        if (this.selectedClient) {
            this.submitted = true;
            this.loading = false;
            this.store.dispatch(selectClient({
                selectedClient: {
                    Id: this.selectedClient.Id,
                    Name: this.selectedClient.Name,
                    Firm: this.selectedClient.Firm,
                },
            }));
        }
    }
    disableSubmission() {
        return this.loading || !this.selectedClient;
    }
}
HartfordClientSearchModalComponent.ɵfac = function HartfordClientSearchModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HartfordClientSearchModalComponent)(i0.ɵɵdirectiveInject(i1.IntegrationErrorHandlingService), i0.ɵɵdirectiveInject(i2.HartfordIntegrationService), i0.ɵɵdirectiveInject(i3.Store)); };
HartfordClientSearchModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HartfordClientSearchModalComponent, selectors: [["ycn-hartford-client-search-modal"]], outputs: { openModalHandler: "openModalHandler" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 4, consts: [["searchInput", ""], ["class", "form-row text-red", 3, "textContent", 4, "ngIf"], [1, "form-row"], ["class", "form-row form-inline", 4, "ngIf"], ["class", "panel-import", 4, "ngIf"], ["class", "input-group", 4, "ngIf"], [1, "form-row", "text-red", 3, "textContent"], [1, "form-row", "form-inline"], [1, "form-label"], [1, "form-control", 3, "change", "value"], ["value", ""], [3, "value", "innerText", 4, "ngFor", "ngForOf"], [3, "value", "innerText"], [1, "panel-import"], [1, "panel-import-header"], [1, "panel-import-title"], [3, "innerText"], [1, "btn", "btn-transparent", 3, "click"], ["ycnIcon", "", 3, "name"], [3, "loaderMessage", 4, "ngIf"], ["class", "panel-import-body", 4, "ngIf"], [3, "loaderMessage"], [1, "panel-import-body"], [3, "pageChangeHandler", "serializedClients", "paginationInfo"], [1, "input-group"], [1, "field-input-group", "input-group"], ["type", "text", 1, "form-control", 3, "input", "keydown.enter", "placeholder", "value"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent"], ["class", "input-group-btn", 4, "ngIf"], [1, "input-group-btn"], [1, "btn", "btn-secondary", 3, "click"]], template: function HartfordClientSearchModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HartfordClientSearchModalComponent_div_0_Template, 1, 1, "div", 1);
        i0.ɵɵelementStart(1, "div", 2);
        i0.ɵɵtemplate(2, HartfordClientSearchModalComponent_div_2_Template, 7, 2, "div", 3)(3, HartfordClientSearchModalComponent_div_3_Template, 8, 4, "div", 4)(4, HartfordClientSearchModalComponent_div_4_Template, 8, 4, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.errorMessage !== "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.territories.length > 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.submitted);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.submitted);
    } }, dependencies: [i4.NgForOf, i4.NgIf, i5.NgSelectOption, i5.ɵNgSelectMultipleOption, i6.IconDirective, i7.LoadingSymbolComponent, i8.HartfordClientListResultsComponent], encapsulation: 2 });
